import { Globals } from "../CoreApp/Globals";

export function handleTimer() {
  var theTarget = Globals._timerMgr.GetTimerTarget();
  if (theTarget) {
    theTarget.DoTimerFire(false);

    var w = Globals._timerMgr.fWSMgr;
    w.RenderWS();
  }
}
